export default __webpack_public_path__ + "static/media/avatar.dfb5700f.png";